import { useTypedSelector } from '../../productInformation/Store/connectors';

export const getImageUrl = (cdnUrl: string, imagePath: string): string => `${cdnUrl}images/${imagePath}`;

export const useImageUrl = (imagePath: string): string => {
    const cdnUrl = useTypedSelector(({ meta }) => meta.cdnUrl);

    return getImageUrl(cdnUrl, imagePath);
};
